<template>
    <ul class="job-page__breadcrumbs">
        <li v-for="({label, url}, i) in breadcrumbs" :key="i" class="breadcrumb">
            <NuxtLink v-if="url && i !== breadcrumbs.length - 1" :to="$withLocalePrefix(url)" external>{{ label }}</NuxtLink>
            <span v-else>{{ locateLabel(label || '') }}</span>
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {JOB_PAGE} from '~/keys';

    const jobPage = inject(JOB_PAGE);
    const location = jobPage?.landingPage?.location;

    const breadcrumbsData = jobPage?.landingPage?.textualContent.breadcrumbs || [];
    const breadcrumbs = breadcrumbsData.map(({label, url}) => {
        let formattedUrl = url;
        if (url === '/') {
            formattedUrl = '/freelancers/categories';
        } else if (!url?.startsWith('/a/')) {
            formattedUrl = `/a${url}`;
        }
        return {label, url: formattedUrl};
    });

    const locateLabel = (label: string) => label.replace(/\{0\}/g, location?.label || '');
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page__breadcrumbs {
        display: flex;
        flex-wrap: wrap;
        column-gap: var(--joy-core-spacing-4);
        margin-bottom: var(--joy-core-spacing-6);
        font-size: var(--joy-font-size-primary-200);

        @include mq.screen_md(min) {
            margin-bottom: var(--joy-core-spacing-8);
            font-size: var(--joy-font-size-primary-400);
        }

        li {
            list-style-type: none;
            white-space: nowrap;

            a,
            a:visited {
                user-select: none;
                color: inherit;
            }

            a:hover {
                text-decoration: underline;
            }

            span {
                font-weight: var(--joy-font-weight-bold);
                cursor: default;
            }

            &:not(:first-child)::before {
                content: '/';
                position: relative;
                left: calc(-1 * var(--joy-core-spacing-2));
            }
        }
    }
</style>
